import React from "react";
import classes from "./InfosPasswordLabels.module.scss";
import { useTranslation } from "react-i18next";
import InfoLabel from "../InfoLabel";
import circleCheckGray from "../../../assets/images/icons/circle-check-gray.svg";
import circleCheckGreen from "../../../assets/images/icons/circle-check-green.svg";

const InfosPasswordLabels = ({
  hasNumber = false,
  hasMinEight = false,
  hasUppercase = false,
  hasLowercase = false,
}) => {
  const { t } = useTranslation();
  let hasNumberIcon = hasNumber ? circleCheckGreen : circleCheckGray;
  let hasMinEightIcon = hasMinEight ? circleCheckGreen : circleCheckGray;
  let hasUppercaseIcon = hasUppercase ? circleCheckGreen : circleCheckGray;
  let hasLowercaseIcon = hasLowercase ? circleCheckGreen : circleCheckGray;
  return (
    <div>
      <InfoLabel
        className={classes.Label}
        icon={<img alt="icon check" src={hasNumberIcon} />}
        text={" " + t("global.at_least_one_number")}
      />
      <InfoLabel
        className={classes.Label}
        icon={<img alt="icon check" src={hasMinEightIcon} />}
        text={" " + t("global.at_least_8_digits")}
      />
      <InfoLabel
        className={classes.Label}
        icon={<img alt="icon check" src={hasUppercaseIcon} />}
        text={" " + t("global.at_least_one_capital_letter")}
      />
      <InfoLabel
        className={classes.Label}
        icon={<img alt="icon check" src={hasLowercaseIcon} />}
        text={" " + t("global.at_least_one_lowercase_letter")}
      />
    </div>
  );
};

export default InfosPasswordLabels;
